import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgOnderzoeksrapport = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F2F5FC"
      d="M23.31 29.84a6.53 6.53 0 1 0 0-13.06 6.53 6.53 0 0 0 0 13.06"
    />
    <path
      fill="#F2F5FC"
      fillRule="evenodd"
      d="M6 34h20V6H12L9 9l-3 3z"
      clipRule="evenodd"
    />
    <path
      fill="#85E3F9"
      fillRule="evenodd"
      d="m6 11.97 2.98-2.99L11.97 6v5.97zM23.59 24.5H14v-1h9.59zM23.59 18.5H14v-1h9.59zM21 30.5h-7v-1h7z"
      clipRule="evenodd"
    />
    <path
      fill="#85E3F9"
      d="M12 28H8v4h4zM12 22H8v4h4zM12 16H8v4h4z"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m14.348 27.16-4.496 4.353-2.217-2.372.73-.682 1.523 1.628 3.764-3.646zM14.348 15.16l-4.496 4.353-2.217-2.372.73-.682 1.523 1.628 3.764-3.646zM26.57 8.58h-6.36v-1h6.36a2.06 2.06 0 0 1 2.06 2.06v1.5h-1v-1.5a1.06 1.06 0 0 0-1.06-1.06"
      clipRule="evenodd"
    />
    <path
      fill="#00C5F2"
      d="m36 33.69-5.5-5.49a8.7 8.7 0 1 0-2.3 2.3l5.49 5.5zm-17.31-5.77a6.53 6.53 0 1 1 9.23 0 6.54 6.54 0 0 1-9.23 0"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgOnderzoeksrapport);

export default ForwardRef;
